// import { createSelector } from 'reselect';

export const getIsPutting = state => state.getIn(['consultationAppoint', 'isPutting']);
export const getErrMsg = state => state.getIn(['consultationAppoint', 'errMsg']);